// TODO: Can this be written in a single line? Like "export default from './configurator'"
import Configurator from './configurator';

export default Configurator;



// WEBPACK FOOTER //
// ./js/components/configuration/index.jsx